import { FontDisplay, loadAsync } from 'expo-font';

import { useEffect, useState } from 'react';
import { logInfo, logWarning } from 'src/_shared/logger';
import { MAIN_FONTS_FILES, CUSTOM_FONTS_FILES } from 'src/constants/font.constants';

export const useEditorFonts = () => {
  const [areMainFontsLoaded, setAreMainFontsLoaded] = useState(false);
  useEffect(() => {
    if (!areMainFontsLoaded) {
      logInfo('[Fonts] [Main] Starting to load main fonts');
      loadFontsAsync(MAIN_FONTS_FILES, 4)
        .then(() => {
          logInfo('[Fonts] [Main] All Main Fonts are loaded!');
        })
        .catch(error => {
          logWarning(`[Fonts] [Main] Error loading Main Fonts: ${error}`);
        })
        .then(() => {
          setAreMainFontsLoaded(true);
        });
    }
  }, []);

  return { areMainFontsLoaded };
};

export const useEditorCustomFonts = (canLoadCustomFonts: boolean) => {
  const [areCustomFontsLoaded, setAreCustomFontsLoaded] = useState(false);

  useEffect(() => {
    if (canLoadCustomFonts && !areCustomFontsLoaded) {
      logInfo('[Fonts] [Custom] Starting to load custom fonts');
      loadFontsAsync(CUSTOM_FONTS_FILES, 4)
        .then(() => {
          logInfo('[Fonts] [Custom] All Custom Fonts are loaded!');
        })
        .catch(error => {
          logWarning(`[Fonts] [Custom] Error loading Custom Fonts: ${error}`);
        })
        .then(() => {
          setAreCustomFontsLoaded(true);
        });
    }
  }, [canLoadCustomFonts]);

  return { areCustomFontsLoaded };
};

const loadFontsAsync = (
  map: Record<string, string>,
  sliceNumber: number,
  initialRemainingFonts?: string[],
): Promise<void> => {
  const remainingFonts = typeof initialRemainingFonts === 'undefined' ? Object.keys(map) : initialRemainingFonts;

  if (remainingFonts.length === 0) {
    return Promise.resolve();
  } else {
    const loadingFontNames = remainingFonts.slice(0, sliceNumber);
    logInfo('[Fonts] Loading fonts...', loadingFontNames);
    const loadingFonts = loadingFontNames.reduce((acc, font) => {
      return { ...acc, [font]: { uri: map[font], display: FontDisplay.SWAP } };
    }, {});

    return loadAsync(loadingFonts).then(() => loadFontsAsync(map, sliceNumber, remainingFonts.slice(sliceNumber)));
  }
};
